import { validateProperty, } from '@debbie/common/dist/properties/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { ChevronDown, ChevronUp } from '../Icons/index.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import Well from '../Well.js';
import { PropertyScopeHeader, groupPropertyTypes } from './Properties.js';
import Property from './Property.js';
const valiateProperties = (propertyTypes, properties) => {
    for (let i = 0; i < propertyTypes.length; i++) {
        const propertyType = propertyTypes[i];
        try {
            validateProperty(propertyType, properties[propertyType.propertyTypeId]);
        }
        catch (error) {
            return false;
        }
    }
    return true;
};
const NewEntityProperties = (props) => {
    const lang = useSelector((s) => s.lang);
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypesGrouped = h.hasData(propertyTypesLoadable)
        ? groupPropertyTypes(propertyTypesLoadable.data, props.propRef, props.caseGroupId)
        : null;
    const propertyTypes = propertyTypesGrouped &&
        propertyTypesGrouped.flatMap((group) => group.propertyTypes);
    const [collapsed, setCollapsed] = useState(false);
    const [properties, setProperties] = useState({});
    const updateProperty = async (prop) => {
        setProperties({
            ...properties,
            [prop.propertyTypeId]: prop.data,
        });
        if (props.propsValid) {
            props.propsValid(valiateProperties(propertyTypes || [], properties));
        }
        props.onChange({
            handle: prop.handle,
            data: prop.data,
            type: prop.type,
            ref: prop.ref,
        });
    };
    useEffect(() => {
        if (propertyTypes && props.propsValid) {
            // TODO: This is a workaround because the properties state is not controlled
            props.propsValid(valiateProperties(propertyTypes || [], properties));
        }
    }, [propertyTypes]);
    return propertyTypes && propertyTypes.length > 0 ? (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                cursor: 'pointer',
                marginBottom: '10px',
            }, onClick: () => setCollapsed(!collapsed) },
            React.createElement("b", null, lang.properties.properties),
            collapsed ? (React.createElement(ChevronDown, { size: 25, style: { float: 'right' } })) : (React.createElement(ChevronUp, { size: 25, style: { float: 'right' } }))),
        !collapsed && (React.createElement(Well, { style: { marginBottom: '20px' } },
            React.createElement(PropertiesStyled, null,
                h.isLoading(propertyTypesLoadable) && React.createElement(PlaceholderLoader, null),
                (propertyTypesGrouped ?? []).map(({ caseGroupId, propertyTypes: _propertyTypes }, index) => (React.createElement("div", { key: caseGroupId ?? 'all' },
                    index !== 0 && React.createElement("hr", null),
                    React.createElement(PropertyScopeHeader, { caseGroupId: caseGroupId }),
                    _propertyTypes.map((propertyType) => (React.createElement(Property, { editable: true, key: propertyType.propertyTypeId, propertyType: propertyType, updateProperty: ({ data }) => updateProperty({
                            propertyTypeId: propertyType.propertyTypeId,
                            handle: propertyType.handle,
                            ref: props.propRef,
                            refId: props.propRefId || null,
                            data: data,
                            type: propertyType.type,
                        }), newEntity: true }))))))))))) : null;
};
export default NewEntityProperties;
const PropertiesStyled = styled.div `
  font-size: 0.75em;
  input,
  select {
    margin-bottom: 0px;
  }
`;
//# sourceMappingURL=NewEntityProperties.js.map